import { useEffect } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Pricing from '../../components/Pricing/Pricing';
import CTA from '../../components/CTA/CTA';
import Footer from '../../components/Footer/Footer';
import './PricingPage.css';

export default function PricingPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pricing-page">
      <Navbar />
      <main className="pricing-page__main">
        <Pricing />
        <CTA />
      </main>
      <Footer />
    </div>
  );
}
